import Cookies from "js-cookie";

const UNKNOWN_AUTHOR = Object.freeze({
  firstName: "Unknown",
  lastName: "",
  email: "",
});

function pickCommentAuthorFields(source) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return null;
  }
  const author = {
    firstName: source.firstName || "",
    lastName: source.lastName || "",
    email: source.email || "",
  };
  if (source._id) {
    author._id = source._id;
  }
  if (author.firstName || author.lastName || author.email || author._id) {
    return author;
  }
  return null;
}

/**
 * Build a minimal comment author payload that is never null.
 * Only identity fields are kept (no token, FCM, addresses, flags, …).
 */
export function buildCommentAuthorFromStorage() {
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      const fromStorage = pickCommentAuthorFields(JSON.parse(raw));
      if (fromStorage) {
        return fromStorage;
      }
    }
  } catch {
    // fall through to cookies / placeholder
  }

  const fromCookies = pickCommentAuthorFields({
    firstName: Cookies.get("firstName") || "",
    email: Cookies.get("userEmail") || "",
  });
  if (fromCookies) {
    return fromCookies;
  }

  return { ...UNKNOWN_AUTHOR };
}

/** Safe label for UI — never throws if author is missing. */
export function getCommentAuthorDisplayName(author, unknownLabel = "Unknown") {
  if (!author || typeof author !== "object") {
    return unknownLabel;
  }
  const fullName = `${author.firstName || ""} ${author.lastName || ""}`.trim();
  return fullName || author.name || author.email || unknownLabel;
}

function tryParseJson(value) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

function isValidCommentEntry(item) {
  return (
    item &&
    typeof item === "object" &&
    !Array.isArray(item) &&
    typeof item.text === "string" &&
    Boolean(item.time)
  );
}

/**
 * Normalize output-client comments into a clean array of { time, text, author? }.
 * Drops invalid entries (e.g. a bare containerId string) that break the UI.
 */
export function parseCommentsList(rawComments) {
  let parsed = tryParseJson(rawComments);
  parsed = tryParseJson(parsed);

  if (!Array.isArray(parsed)) {
    return [];
  }

  return parsed.filter(isValidCommentEntry);
}
